<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div class="section operations" style="height: 39px;">
          <div class="triggers">
            <div>
              <span style="display: inline-block;width: 90px;color: #333333">{{ $t('CargoMsg.Cargo_Months') }}</span>
              <el-input-number
                v-model="currentMonth"
                no="currentMonth"
                controls-position="right"
                :disabled="isCopySave"
                style="margin-right: 5px;"
                @change="handleChange"
                @keyup.enter.native="handleNativeChange"
              />
              <span v-if="isCopySave">
                <el-button no="copySave" type="primary" @click="copySave">{{ $t('common.btn.save') }}</el-button>
                <el-button no="copyCancel" type="primary" @click="copyCancel">{{ $t('common.btn.cancel') }}</el-button>
              </span>
              <span v-else>
                <el-upload
                  no="saveExcelFile2"
                  :action="url.mdm.rate.saveExcelFile2"
                  :headers="{sessionId}"
                  :data="{hqRate: hqRate, branchId: officeId, enabledChildOffice: enabledChildOffice}"
                  :show-file-list="false"
                  accept=".xls, .xlsx"
                  :before-upload="beforeUpload"
                  :on-success="uploadSuccess"
                  style="display: inline-block;"
                >
                  <el-button v-if="((hqRate && $checkPermission(['write_SMRate'])) || (!hqRate && $checkPermission(['write_SMRate_updateOfficeRate']))) && !isParentRate" no="excelImport" type="primary">{{ $t('SeaExport.ExcelImport') }}</el-button>
                </el-upload>
                <el-button v-if="((hqRate && $checkPermission(['write_SMRate'])) || (!hqRate && $checkPermission(['write_SMRate_updateOfficeRate']))) && !isParentRate" no="new" type="primary" @click="popRateManagementAddFormDialog">
                  {{ $t('common.btn.new') }}
                </el-button>
                <el-button v-if="((hqRate && $checkPermission(['write_SMRate'])) || (!hqRate && $checkPermission(['write_SMRate_updateOfficeRate']))) && !isParentRate" no="edit" type="primary" @click="popRateManagementEditFormDialog">
                  {{ $t('common.btn.edit') }}
                </el-button>
                <el-button v-if="((hqRate && $checkPermission(['role_SMRate_copy'])) || (!hqRate && $checkPermission(['role_SMRate_copyOfficeRate']))) && !isParentRate" no="copyRate" type="primary" @click="popRateManagementCopyFormDialog">{{ $t('baseInfo.rateManagement.copyRate') }}
                </el-button>
                <el-button v-if="((hqRate && $checkPermission(['role_SMRate_remove'])) || (!hqRate && $checkPermission(['role_SMRate_removeOfficeRate']))) && !isParentRate" no="delete" type="danger" @click="toDelete">{{ $t('common.btn.delete') }}</el-button>
                <el-button v-if="isAdmin && hqRate" no="setRateCacheRange" type="primary" @click="setRateCacheRange">{{ $t('baseInfo.rateManagement.setRateCacheRange') }}</el-button>
                <el-button v-if="!isParentRate" no="excelExport" type="primary" @click="exportHandler">{{ $t('SeaExport.ExcelExport') }}</el-button>
                <el-button v-show="isPlatformService && hqRate" no="initRatePeriod" type="primary" @click="initRatePeriodHandler">{{ $t('CargoMsg.Cargo_initRatePeriod') }}</el-button>
                <el-button v-if="!hqRate && $checkPermission(['role_SMRate_enabledChildOffice']) && !isParentRate" no="setEnabledChild" type="primary" @click="popSetEnabledChildDialog">{{ $t('CargoMsg.Cargo_SetEnabledChild') }}</el-button>
              </span>
              <label v-if="!isMaintainEdit" style="color:#BBBBBB;margin-left: 15px">
                {{ showRateRatio }}
              </label>
              <label v-if="!isMaintainEdit && !hqRate" style="margin-left: 100px">
                {{ showParentRateOffice }}
              </label>
              <label v-if="!isMaintainEdit && !hqRate" style="margin-left: 15px">
                {{ enabledChildOfficeLabel }}
              </label>
            </div>
          </div>
        </div>
        <div class="section grid-wrapper" style="min-height:350px">
          <cargo-ag-grid
            no="grid1"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            config-module="183345"
            :check-main-record="false"
            :deselect-main-record="false"
            :show-selected-color="false"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
      </div>
    </div>
    <!-- 费率维护 -->
    <el-dialog
      slot="reference"
      v-el-drag-dialog
      no="rateMaintain"
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="showMaintain"
      :title="$t('baseInfo.rateManagement.rateMaintain')"
      inline-message
      width="405px"
    >
      <el-form ref="rateManagementForm" :model="rateManagementForm" label-width="130px" label-position="right">
        <el-form-item :label="$t('baseInfo.rateManagement.currency')">
          <cargo-advance-select
            no="currency"
            :select-type="selectTypeNames.basic_data_Currency"
            :callback-params="{key:'currency'}"
            callback-method-type="value"
            :default-value="rateManagementForm.currency"
            filterable
            style="width:205px;"
            @parentCallBack="selectCargoItem"
          />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.rateManagement.baseCuurency')">
          <cargo-advance-select
            no="baseCurrency"
            :select-type="selectTypeNames.basic_data_Currency"
            :callback-params="{key:'baseCuurency'}"
            callback-method-type="value"
            :default-value="rateManagementForm.baseCuurency"
            filterable
            :clearable="false"
            style="width:205px;"
            @parentCallBack="selectCargoItem"
          />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.rateManagement.rate')">
          <el-input
            v-stopNumberMousewheel
            :value="rateManagementForm.rate"
            no="rate"
            type="number"
            style="width: 130px;"
            @input="onRateInput"
            @change="onRateChange"
          />
        </el-form-item>
        <el-form-item :label="$t('baseInfo.rateManagement.month')" prop="month">
          <el-input v-model="rateManagementForm.month" no="month" disabled style="width: 130px;" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_UsePeriodRate')">
          <el-radio-group v-model="rateManagementForm.usePeriodRate" no="usePeriodRate" @change="rbgUsePeriodRateChangeHandler">
            <el-radio style="margin-right: 10px;" :label="true">{{ $t('CargoMsg.Cargo_Yes') }}</el-radio>
            <el-radio style="margin-right: 10px;" :label="false">{{ $t('CargoMsg.Cargo_No') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="rateManagementForm.usePeriodRate" label-width="0">
          <el-button no="add" type="primary" @click="addHandler">{{ $t('CargoMsg.Cargo_add') }}</el-button>
          <el-button no="del" type="danger" @click="delHandler">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
        </el-form-item>
      </el-form>
      <cargo-ag-grid
        v-show="rateManagementForm.usePeriodRate"
        no="grid2"
        :show-side-bar="false"
        :auto-fit-content="false"
        config-module="183346"
        :grid-params.sync="rateGridParams"
        :grid-options="rateGridOptions"
        :column-defs="rateColumnDefs"
        :row-data="rateRowData"
      />
      <div slot="footer">
        <el-button no="save" type="primary" @click="submitRateManagement">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 复制利率 -->
    <el-dialog
      slot="reference"
      v-el-drag-dialog
      no="copyRateMaintain"
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="showCopyMaintain"
      :title="$t('baseInfo.rateManagement.copyRateMaintain')"
      inline-message
      width="400px"
    >
      <el-form :inline="true" label-width="90px" label-position="left">
        <div class="el-form-item-wrapper">
          <el-form-item v-if="!hqRate" style="padding-left:20px;padding-bottom:5px">
            <el-radio-group v-model="copyHqRate" no="copyHqRate" @change="fetchCopyRateList">
              <el-radio :label="false">{{ $t('CargoMsg.Cargo_CopyOfficeRate') }}</el-radio>
              <el-radio :label="true">{{ $t('CargoMsg.Cargo_CopyHqRate') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Months')">
            <el-input-number
              v-model="copyCurrentMonth"
              no="copyCurrentMonth"
              controls-position="right"
              @change="copyHandleChange"
            />
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button no="submitCopyRateManagement" type="primary" @click="submitCopyRateManagement">{{ $t('common.btn.save') }}
        </el-button>
        <el-button no="cancelCopySaveOrEdit" @click="cancelCopySaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <rate-cache-range-dialog :visible.sync="maintainRateCacheRangeControl" />
    <!-- 设置子公司生效 -->
    <el-dialog
      slot="reference"
      v-el-drag-dialog
      no="setEnabledChildDialog"
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="showSetEnabledChildDialog"
      :title="$t('CargoMsg.Cargo_SetEnabledChildDialog')"
      inline-message
      width="400px"
    >
      <el-form :inline="true" label-width="80px" label-position="left">
        <div class="el-form-item-wrapper">
          <el-form-item style="padding-left: 20px">
            <el-checkbox v-model="setEnabledChildValue">{{ $t('CargoMsg.Cargo_SetEnabledChildCheckbox') }}</el-checkbox>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button no="submitSetEnabledChild" type="primary" @click="submitSetEnabledChild">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="cancelSetEnabledChild" @click="cancelSetEnabledChild">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import URL from '@/api/urlTranslator'

import { getRatePeriodList, addRatePeriod, detailRatePeriod, updateRatePeriod, batchDelRatePeriod, copyRatePeriod, confirmCopyRate, initRatePeriod, batchDelRateBranch, setEnabledChild } from '@/api/rate'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getGridSelected } from '@/utils/agGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import lodash from 'lodash'
import { getToken } from '@/utils/auth'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { syncSpecificBasicData } from '@/utils/basicDataCache'
import { exportExcel } from '@/utils/tableDataExportUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor'
import moment from 'moment'
import StrUtils from '@/utils/StrUtils'
import { isNumber } from '@/utils/validate'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import RateCacheRangeDialog from '@/views/cargo/v0/Information/RateCacheRangeDialog.vue'
import { getOfficeById } from '@/api/office'

export default {
  name: 'RatePeriod',
  components: { RateCacheRangeDialog, cargoAdvanceSelect },
  props: {
    hqRate: { type: Boolean, default: true } // 默认，集团汇率
  },
  data() {
    return {
      sessionId: getToken(),
      loading: false,
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      columnDefs: [
        {
          headerName: this.$t('baseInfo.rateManagement.benchmarkCurrency'),
          field: 'baseCurrency'
        }, {
          headerName: this.$t('baseInfo.rateManagement.rate'),
          field: 'rate',
          width: 140,
          cellRenderer: (params) => {
            return params.value ? this.$numeral(params.value).format('0,0.00000000') : ''
          }
        }, {
          headerName: this.$t('baseInfo.rateManagement.effectiveMonth'),
          field: 'month'
        }, {
          headerName: this.$t('Pricing.StartTime'), field: 'startDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('Pricing.EndTime'), field: 'endDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_UsePeriodRate'),
          field: 'usePeriodRate',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          cellStyle: { textAlign: 'center' }
        }, {
          headerName: this.$t('CargoMsg.Cargo_MonthRate'),
          field: 'monthRate',
          width: 140,
          cellRenderer: (params) => {
            return params.value ? this.$numeral(params.value).format('0,0.00000000') : ''
          }
        }],
      rowData: [],
      copyRowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressDoubleClickExpand: true,
        treeData: true,
        groupDefaultExpanded: 1,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('baseInfo.rateManagement.originalCurrency'),
          field: 'currency',
          width: 120,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              return true
            }
          }
        },
        pagination: false,
        onRowClicked: this.onRowCLick,
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
          if (nodes && nodes.length > 0) {
            this.setShowRateRatio(nodes[0].data)
            this.setShowParentRateOffice(nodes[0].data)
          }
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        }
      },
      selectedNode: null,
      currentMonth: '',
      copyCurrentMonth: '',
      showMaintain: false,
      showCopyMaintain: false,
      isMaintainEdit: false,
      initRateManagementForm: {
        uuid: '',
        tenantId: '',
        baseCuurency: 'RMB',
        currency: '',
        rate: '0.00000000',
        month: 1,
        version: '',
        usePeriodRate: false,
        fxRatePeriod: []
      },
      rateManagementForm: {},
      originBaseCuurency: '',
      originCurrency: '',
      showRateRatio: '',
      isCopySave: false,
      selectedRate: null,
      rateGridParams: {},
      rateGridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: true,
        suppressClipboardPaste: true,
        suppressRowClickSelection: false,
        singleClickEdit: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          sortable: false,
          resizable: false,
          menuTabs: []
        },
        frameworkComponents: {
          CargoAgGridCommonInputEditor,
          CargoAgGridDateTimeEditor
        },
        onRowClicked: this.onRateGridRowClicked
      },
      pickerOption: {
        disabledDate: this.disabledDate
      },
      copyRateList: [], // 确认复制的汇率
      copyRatePeriodList: [],
      copyRateUuids: [],
      copySaving: false,
      maintainRateCacheRangeControl: false,
      enabledChildOffice: false, // 设置对下级子公司生效
      showSetEnabledChildDialog: false,
      setEnabledChildValue: false,
      showParentRateOffice: '', // 应用上级分公司汇率
      copyHqRate: false // 复制集团汇率
    }
  },
  computed: {
    url() {
      return URL
    },
    computeCurrentMonth() {
      const date = new Date()
      return date.getFullYear() + (date.getMonth() + 1).toString().padStart(2, '0')
    },
    rateColumnDefs() {
      return [
        {
          headerName: this.$t('Pricing.StartTime'), field: 'startDate', width: 120, sortable: false, editable: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false,
              pickerOptions: this.pickerOption
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('Pricing.EndTime'), field: 'endDate', width: 120, sortable: false, editable: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          cellEditor: 'CargoAgGridDateTimeEditor',
          cellEditorParams: {
            props: {
              type: 'date',
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd',
              editable: false,
              pickerOptions: this.pickerOption
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('baseInfo.rateManagement.rate'), field: 'rate', width: 140, sortable: false, editable: true,
          cellRenderer: (params) => {
            return params.value ? this.$numeral(params.value).format('0,0.00000000') : ''
          },
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }]
    },
    // 汇率列表
    rateRowData() {
      console.log('rateRowData', this.rateManagementForm)
      if (this.rateManagementForm !== null && this.rateManagementForm.fxRatePeriod !== null) {
        return this.rateManagementForm.fxRatePeriod
      }
      return []
    },
    monthDate() {
      if (this.rateManagementForm !== null && !StrUtils.isEmpty(this.rateManagementForm.month)) {
        const month = this.rateManagementForm.month.toString()
        return month.slice(0, 4) + '-' + month.slice(4) + '-01'
      }
      return new Date()
    },
    isPlatformService() {
      return this.$store.getters.userInfo.chineseName === '平台客服'
    },
    isAdmin() {
      return this.$store.getters.isAdmin
    },
    officeId() { // 当前分公司Id
      return this.$store.getters.currentOfficeId
    },
    // 是否对下级子公司生效
    enabledChildOfficeLabel() {
      if (!this.hqRate && this.enabledChildOffice) {
        return this.$t('CargoMsg.Cargo_EnabledChildOffice')
      }
      return ''
    },
    // 是否上级分公司汇率
    isParentRate() {
      if (!this.hqRate && this.rowData && this.rowData.length > 0) {
        for (const data of this.rowData) {
          if (data && data.enabled && data.parentBranchId && data.parentBranchId !== this.officeId) {
            return true
          }
        }
      }
      return false
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        if (!this.hqRate) {
          this.getEnabledChildOffice()
          this.fetchRateList()
        }
      }
    }
  },
  mounted() {
    // 初始化当前月份
    this.currentMonth = this.computeCurrentMonth
    this.fetchRateList()
  },
  methods: {
    handleChange(value) {
      value = value + ''
      this.currentMonth = this.generationMonth(value)
      this.copyCurrentMonth = this.generationLastMonth(value)
      this.fetchRateList()
      if (!this.isMaintainEdit) {
        this.rateManagementForm.month = this.currentMonth
      }
    },
    handleNativeChange() {
      this.currentMonth = this.generationMonth(this.currentMonth)
      this.copyCurrentMonth = this.generationLastMonth(this.currentMonth)
      this.fetchRateList()
      if (!this.isMaintainEdit) {
        this.rateManagementForm.month = this.currentMonth
      }
    },
    copyHandleChange(value) {
      value = value + ''
      this.copyCurrentMonth = this.generationMonth(value)
      this.fetchCopyRateList()
    },
    // 生成月份 格式yyyyMM
    generationMonth(value) {
      if (value) {
        // 获取月份
        let year = value.slice(0, 4)
        // 获取年份
        let month = value.slice(4)

        if (month > 12) {
          year = Number(year) + 1
          month = '01'
        }
        if (month <= 0) {
          year = Number(year) - 1
          month = '12'
        }
        return year + month
      }
      return ''
    },
    // 生成月份 格式yyyyMM
    generationLastMonth(value) {
      if (value) {
        // 获取月份
        let year = value.slice(0, 4)
        // 获取年份
        let month = value.slice(4)
        month = month - 1
        if (month <= 0) {
          year = Number(year) - 1
          month = '12'
        } else {
          month = this.prefixInteger(month, 2)
        }
        return year + month
      }
      return ''
    },
    onRateInput(value) {
      // 非数字
      if (/[^0-9.]/.test(value)) {
        return
      }
      // indexOf、lastIndexOf的返回值分三种情况：
      // 1、没有“.”，都是-1（相等）
      // 2、有一个“.”，都是同一个值（相等）
      // 3、有两个及以上的“.”，值不一样（不相等）
      if (value.indexOf('.') !== value.lastIndexOf('.')) {
        return
      }
      this.rateManagementForm.rate = value
    },
    onRateChange(value) {
      if (isNumber(value)) {
        this.rateManagementForm.rate = Number(CurrencyUtil.truncateRateByCurrency(this.rateManagementForm.currency, value)).toFixed(8)
      } else {
        this.rateManagementForm.rate = '0.00000000'
      }
    },
    // 获取费率列表
    fetchRateList() {
      const self = this
      const params = {
        currentYearMonth: this.currentMonth, hqRate: this.hqRate, branchId: this.officeId
      }
      getRatePeriodList(params).then(res => {
        self.rowData = res.data
        if (self.rowData.length <= 0) {
          this.showRateRatio = ''
          this.showParentRateOffice = ''
        }
      }).catch(() => {
      })
      this.selectedNode = null
      if (this.gridOptions.api) this.gridOptions.api.clearFocusedCell()
    },
    setShowRateRatio(data) {
      if (data) {
        this.showRateRatio = '1 ' + data.currency + '= ' + this.$numeral(data.rate).format('0,0.00000000') + ' ' + data.baseCurrency
      } else {
        this.showRateRatio = ''
      }
    },
    // 获取复制费率列表
    fetchCopyRateList() {
      const self = this
      const params = {
        currentYearMonth: this.copyCurrentMonth, hqRate: this.hqRate, copyHqRate: this.copyHqRate, branchId: this.officeId
      }
      getRatePeriodList(params).then(res => {
        self.copyRowData = res.data
      }).catch(() => {
      })
    },
    popRateManagementAddFormDialog() {
      this.rateManagementForm = { ...this.initRateManagementForm }
      this.rateManagementForm.month = this.currentMonth
      this.rateManagementForm.fxRatePeriod = []
      this.isMaintainEdit = false
      this.showMaintain = true
    },
    popRateManagementCopyFormDialog() {
      this.copyHqRate = false
      // 初始化当前月份
      this.copyCurrentMonth = this.generationLastMonth(this.currentMonth + '')
      this.fetchCopyRateList()
      this.showCopyMaintain = true
    },
    popRateManagementEditFormDialog() {
      const self = this
      const selectedRows = getGridSelected(this.gridOptions)
      if (selectedRows.length !== 1) {
        self.$message.error(self.$t('common.tips.hasOneOnly'))
        return
      }
      this.loading = getLoading()
      detailRatePeriod({ 'uuid': selectedRows[0].fxRateUuid, hqRate: this.hqRate, branchId: this.officeId, enabledChildOffice: this.enabledChildOffice }).then(res => {
        console.log('detailRatePeriod', res)
        self.rateManagementForm = res.data
        self.originBaseCuurency = self.rateManagementForm.baseCuurency
        self.originCurrency = self.rateManagementForm.currency
        for (const rate of self.rateManagementForm.fxRatePeriod) {
          rate.index = Math.floor(Math.random() * 1000)
        }
        self.isMaintainEdit = true
        self.showMaintain = true
        self.rateManagementForm.rate = self.rateManagementForm.rate ? this.$numeral(self.rateManagementForm.rate).format('0.00000000') : ''
        this.$nextTick(() => {
          this.rateGridOptions.api.deselectAll()
          const nodes = this.rateGridOptions.api.getRenderedNodes()
          let lastNode = null
          for (const node of nodes) {
            if (node.data.uuid === selectedRows[0].uuid) {
              lastNode = node
              break
            }
          }
          this.rateGridOptions.api.clearFocusedCell()
          if (lastNode !== null) {
            lastNode.setSelected(true)
            this.rateGridOptions.api.setFocusedCell(lastNode.rowIndex, 'startDate')
          }
        })
      }).finally(() => {
        this.loading.close()
      })
      this.$forceUpdate()
    },
    setRateCacheRange() {
      this.maintainRateCacheRangeControl = true
    },
    // 删除
    async toDelete() {
      const self = this
      const selectedRows = getGridSelected(this.gridOptions)
      if (selectedRows.length === 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const ids = []
      for (const row of selectedRows) {
        if (ids.indexOf(row.fxRateUuid) === -1) ids.push(row.fxRateUuid)
      }
      if (ids.length === 0) return
      await self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.confirm'), { type: 'warning' })
      self.loading = getLoading()
      if (!this.hqRate) {
        batchDelRateBranch({ uuids: ids, hqRate: this.hqRate, branchId: this.officeId, enabledChildOffice: this.enabledChildOffice }).then(() => {
          this.deleteSuccessHandler()
        }).finally(() => {
          self.loading.close()
        })
      } else {
        batchDelRatePeriod(ids).then(() => {
          this.deleteSuccessHandler()
        }).finally(() => {
          self.loading.close()
        })
      }
    },
    deleteSuccessHandler() {
      this.fetchRateList()
      this.refreshRateCache()
      this.$message.success(this.$t('common.tips.deleteSuccess'))
    },
    getRateManagementSelected() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length <= 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return null
      }
      return selectedRows
    },
    submitRateManagement() {
      if (!this.toCheckRateForm(this.rateManagementForm)) {
        return
      }
      if (!this.toCheckRatePeriod()) {
        return
      }
      if (!this.isMaintainEdit) {
        this.toAddRateManagement()
      } else {
        // 复制利率进行编辑
        if (this.isCopySave) {
          for (let i = 0; i < this.rowData.length; i++) {
            if (this.rowData[i]['uuid'] === this.rateManagementForm.uuid) {
              this.rowData[i]['currency'] = this.rateManagementForm.currency
              this.rowData[i]['baseCuurency'] = this.rateManagementForm.baseCuurency
              this.rowData[i]['rate'] = this.rateManagementForm.rate
              // type为空 那就赋值以后 type 2
              if (!this.rateManagementForm.type) {
                this.rowData[i]['type'] = 2
              }
            }
          }
          this.showMaintain = false
          const params = {
            force: true
          }
          this.gridOptions.api.refreshCells(params)
        } else {
          this.isMaintainEdit = false
          this.toEditRateManagement()
        }
      }
    },
    // 检查汇率表单
    toCheckRateForm(opt) { // opt=> add,edit
      const { currency, rate } = opt
      let errorMsg = ''
      if (!currency) {
        errorMsg += this.$t('baseInfo.rateManagement.currencyCheck')
      }
      if (!rate) {
        errorMsg += this.$t('baseInfo.rateManagement.rateCheck')
      }
      // 汇率长度限制
      const rateLength = this.rateManagementForm.rate.split('.')[0].length
      if (rateLength.length > 6) {
        errorMsg += this.$t('baseInfo.rateManagement.rateIsTooLong')
      }
      let duplicated = false
      if (!this.isMaintainEdit) {
        if (this.hasDuplicate({ ...this.rateManagementForm })) {
          errorMsg += this.$t('baseInfo.rateManagement.repeatCheck2').format(this.rateManagementForm.currency, this.rateManagementForm.baseCuurency)
          duplicated = true
        }
      }
      if (!duplicated && !(this.isMaintainEdit && this.originBaseCuurency === this.rateManagementForm.baseCuurency && this.originCurrency === this.rateManagementForm.currency)) {
        if (this.hasDuplicate({ ...this.rateManagementForm })) {
          errorMsg += this.$t('baseInfo.rateManagement.repeatCheck2').format(this.rateManagementForm.currency, this.rateManagementForm.baseCuurency)
        }
      }
      if (errorMsg) {
        this.$message.warning(errorMsg)
        return
      } else {
        return true
      }
    },
    // 编辑汇率
    toEditRateManagement() {
      this.copySaving = true
      if (!this.rateManagementForm.usePeriodRate) {
        this.rateManagementForm.fxRatePeriod = []
        this.addHandler()
      }
      this.rateManagementForm.hqRate = this.hqRate
      this.rateManagementForm.branchId = this.officeId
      this.rateManagementForm.enabledChildOffice = this.enabledChildOffice
      updateRatePeriod(this.rateManagementForm).then(res => {
        this.showMaintain = false
        this.refreshRateCache()
        this.$message({ message: this.$t('common.tips.editSuccess'), type: 'success' })
      }).then(() => {
        this.copySaving = false
        this.fetchRateList()
      })
    },
    // 新增汇率
    toAddRateManagement() {
      this.copySaving = true
      if (!this.rateManagementForm.usePeriodRate) {
        this.rateManagementForm.fxRatePeriod = []
        this.addHandler()
      }
      this.rateManagementForm.hqRate = this.hqRate
      this.rateManagementForm.branchId = this.officeId
      this.rateManagementForm.enabledChildOffice = this.enabledChildOffice
      addRatePeriod(this.rateManagementForm).then(res => {
        this.showMaintain = false
        this.refreshRateCache()
        this.$message({ message: this.$t('common.tips.saveSuccess'), type: 'success' })
      }).then(() => {
        this.copySaving = false
        this.fetchRateList()
      })
    },
    // 取消保存或者编辑
    cancelSaveOrEdit() {
      this.rateManagementForm = { ...this.initRateManagementForm }
      this.showMaintain = false
      this.isMaintainEdit = false
    },
    // 验证是否存在重复的配置
    hasDuplicate(rateManagementObj) {
      if (this.rowData.length > 0) {
        for (let i = 0; i < this.rowData.length - 1; i++) {
          if (rateManagementObj['currency'] === this.rowData[i]['currency'] && rateManagementObj['baseCuurency'] === this.rowData[i]['baseCurrency']) {
            return true
          }
        }
      }
      return false
    },
    // 检查复制汇率表单
    toCheckCopyRateForm() {
      let errorMsg = ''
      if (this.copyCurrentMonth === this.currentMonth) {
        errorMsg += this.$t('baseInfo.rateManagement.copyCurrentMonthCheck')
      }
      if (this.copyRowData.length <= 0) {
        errorMsg += this.$t('baseInfo.rateManagement.copyRowDataCheck')
      }
      if (!errorMsg) {
        return true
      }
      this.$message.error(errorMsg)
    },
    // 提交复制汇率
    submitCopyRateManagement() {
      if (!this.toCheckCopyRateForm()) {
        return
      }
      const self = this
      const params = {
        currentYearMonth: this.currentMonth,
        copyCurrentYearMonth: this.copyCurrentMonth,
        hqRate: this.hqRate,
        copyHqRate: this.copyHqRate,
        branchId: this.officeId
      }
      // 确认是否有相同汇率
      confirmCopyRate(params).then(res => {
        this.copyRateList = []
        this.copyRateUuids = []
        this.copyRatePeriodList = []
        this.isCopySave = true
        this.showCopyMaintain = false
        if (res.data['waitUpdate'].length > 0) {
          this.$confirm(this.$t('Information.WhetherToOverwriteExistingData'), this.$t('Information.Overwrite'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            closeOnClickModel: false,
            type: 'warning'
          }).then(() => {
            // 新增的
            if (res.data['waitAdd'].length > 0) {
              for (let i = 0; i < res.data['waitAdd'].length; i++) {
                res.data['waitAdd'][i].month = this.currentMonth
                res.data['waitAdd'][i].type = 1
                this.copyRateList.push(res.data['waitAdd'][i])
                this.copyRateUuids.push(res.data['waitAdd'][i].uuid)
              }
            }
            // 覆盖的
            if (res.data['waitUpdate'].length > 0) {
              for (let i = 0; i < res.data['waitUpdate'].length; i++) {
                res.data['waitUpdate'][i].month = this.currentMonth
                res.data['waitUpdate'][i].type = 2
                this.copyRateList.push(res.data['waitUpdate'][i])
                this.copyRateUuids.push(res.data['waitUpdate'][i].uuid)
              }
            }
            // 原来的
            for (const row of this.rowData) {
              let bUpdate = false
              for (const updateRow of res.data['waitUpdate']) {
                if (row.baseCurrency === updateRow.baseCuurency && row.currency === updateRow.currency) {
                  bUpdate = true
                  break
                }
              }
              if (!bUpdate && this.copyRateUuids.indexOf(row.fxRateUuid) === -1) { this.copyRateUuids.push(row.fxRateUuid) }
            }
            this.fetchCopyRateAll()
          }).catch(() => {
            // 新增的
            if (res.data['waitAdd'].length > 0) {
              for (let i = 0; i < res.data['waitAdd'].length; i++) {
                res.data['waitAdd'][i].month = this.currentMonth
                res.data['waitAdd'][i].type = 1
                this.copyRateList.push(res.data['waitAdd'][i])
                this.copyRateUuids.push(res.data['waitAdd'][i].uuid)
              }
            }
            // 原来的
            for (const row of this.rowData) {
              if (this.copyRateUuids.indexOf(row.fxRateUuid) === -1) { this.copyRateUuids.push(row.fxRateUuid) }
            }
            this.fetchCopyRateAll()
          })
        } else {
          if (res.data['waitAdd'].length > 0) {
            for (let i = 0; i < res.data['waitAdd'].length; i++) {
              res.data['waitAdd'][i].month = this.currentMonth
              res.data['waitAdd'][i].type = 1
              this.copyRateList.push(res.data['waitAdd'][i])
              this.copyRateUuids.push(res.data['waitAdd'][i].uuid)
            }
          }
          for (const row of this.rowData) {
            if (this.copyRateUuids.indexOf(row.fxRateUuid) === -1) { this.copyRateUuids.push(row.fxRateUuid) }
          }
          this.fetchCopyRateAll(true)
        }
      })
    },
    // 取消复制汇率
    cancelCopySaveOrEdit() {
      this.showCopyMaintain = false
    },
    selectCargoItem(item) {
      this.rateManagementForm[item.key] = item.value
    },
    exportExcel() {
      const self = this
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          self.$t('baseInfo.rateManagement.originalCurrency'),
          self.$t('baseInfo.rateManagement.benchmarkCurrency'),
          self.$t('baseInfo.rateManagement.rate'),
          self.$t('baseInfo.rateManagement.effectiveMonth')
        ]
        const filterVal = ['currency', 'baseCuurency', 'rate', 'month']
        const data = self.formatJson(filterVal, [])
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'Rate'
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    onRowCLick(event) {
      this.selectedNode = event.data
      if (this.gridOptions.api) {
        const rate = event.data
        if (rate) {
          this.showRateRatio = '1 ' + rate.currency + '= ' + this.$numeral(rate.rate).format('0,0.00000000') + ' ' + rate.baseCurrency
          this.setShowParentRateOffice(rate)
        }
      }
    },
    copySave() {
      this.copySaving = true
      const params = {
        currentYearMonth: this.currentMonth,
        copyCurrentYearMonth: this.copyCurrentMonth,
        sysFxRateList: this.copyRateList,
        ratePeriodList: this.copyRatePeriodList,
        hqRate: this.hqRate,
        copyHqRate: this.copyHqRate,
        branchId: this.officeId,
        enabledChildOffice: this.enabledChildOffice
      }
      copyRatePeriod(params).then(res => {
        this.copyRowData = []
        this.isCopySave = false
        this.refreshRateCache()
        this.$message({ message: this.$t('baseInfo.rateManagement.copyRateSuccess'), type: 'success' })
      }).then(() => {
        this.fetchRateList()
      }).catch(() => {
      }).finally(() => {
        this.copySaving = false
      })
    },
    copyCancel() {
      this.isCopySave = false
      this.fetchRateList()
    },
    prefixInteger(num, length) {
      return (Array(length).join('0') + num).slice(-length)
    },
    exportHandler() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      const self = this
      if (selectedRows.length === 0) {
        self.$message.warning(this.$t('Information.PleaseDataYouWantExport'))
        return
      }
      const rows = lodash.cloneDeep(selectedRows)
      var timestamp = new Date().getTime()
      console.log('====开始时间======', timestamp)
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      // 获取选中行
      const fileName = 'RatePeriodList'
      exportExcel(fileName, rows, allDisplayedColumns, true)
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('Information.TheOnlyBeXlsFormat'))
      }
      if ((Math.round(file.size * 100 / (1024 * 1024)) / 100) > 2) {
        this.$message.warning(this.$t('Information.FileBeLargerThan2MB'))
        return false
      }
      return extension || extension2
    },
    uploadSuccess(response, file, fileList) {
      if (response) {
        if (response.code === '0') {
          this.onImportSucceeded(response.data)
        } else {
          this.onImportFailed(response)
        }
      } else {
        this.$message.warning(this.$t('Information.ImportPleaseContactTheAdministrator'))
      }
    },
    onImportSucceeded(msg) {
      if (msg.split(':').length > 2) {
        // 一个Excel中有多个sheet包含数据
        msg = msg.replace('records.', this.$t('Information.Items'))
        msg = this.$t('Information.recordsImportedIntoTheSystem').replace('@records', '\n' + msg + '\n\t')
      } else {
        // 仅一个sheet
        msg = msg.replace('records.', this.$t('Information.Items2'))
        msg = msg.split(':')[1]
        msg = this.$t('Information.recordsImportedIntoTheSystem').replace('@records', msg)
      }
      this.onSaveSucceed()
      this.$message.success(msg)
    },
    onImportFailed(info) {
      let msg = ''
      if (info.code === '531603') {
        const data = JSON.parse(info.message)
        // 1为导入的Excel中数据之间有重复 2为导入的Excel中数据与表中已有数据重复
        if (data.repeatType === '1') {
          msg = this.$t('Information.TheValueIs0Excel', [data.currency, data.baseCurrency])
        } else if (data.repeatType === '2') {
          msg = this.$t('Information.TheIs0WhichTable', [data.currency, data.baseCurrency])
        } else {
          msg = this.$t('Information.DataExistingDataInTable')
        }
      } else {
        msg = info.message
        const index = msg.indexOf('1')
        if (index > -1) msg = msg.substr(index)
      }
      this.$message.error(msg)
    },
    onSaveSucceed() {
      this.refreshRateCache()
      // CacheManager.getInstance().loadCache('Rate')
      this.currentMonth = this.computeCurrentMonth
      this.fetchRateList()
    },
    // 行选择事件
    onRateGridRowClicked(event) {
      console.log('onRateGridRowClicked', event)
      if (!event.data) return
      this.selectedRate = event.data
    },
    onCellChange(params) {
      console.log('onCellChange', params)
      if (params.colDef.field === 'rate') {
        const rate = CurrencyUtil.truncateRateByCurrency(this.rateManagementForm.currency, params.data.rate)
        if (rate !== params.data.rate) {
          params.node.setDataValue('rate', rate)
          return
        }
      }
      const field = params.colDef.field
      switch (field) {
        case 'startDate':

          break
        case 'endDate':

          break
        case 'rate':

          break
        default:
      }
      this.$nextTick(() => {
        this.rateGridOptions.api.refreshCells({ force: true })
      })
    },
    // 添加
    addHandler() {
      const row = {
        index: Math.floor(Math.random() * 1000),
        startDate: null,
        endDate: null,
        rate: this.rateManagementForm.rate
      }
      // 开始时间
      if (this.rateManagementForm.usePeriodRate) {
        const rowSize = this.rateManagementForm.fxRatePeriod.length
        // 一行都没有
        if (rowSize === 0) {
          row.startDate = moment(this.monthDate).startOf('month').format('YYYY-MM-DD')
        } else {
          // 上一行 结束时间 + 1
          const lastRow = this.rateManagementForm.fxRatePeriod[rowSize - 1]
          if (lastRow.endDate && moment(lastRow.endDate).format('yyyy-MM-DD') !== moment(this.monthDate).endOf('month').format('YYYY-MM-DD')) {
            row.startDate = moment(lastRow.endDate).add(1, 'days').format('YYYY-MM-DD')
          }
        }
      } else {
        row.startDate = moment(this.monthDate).startOf('month').format('YYYY-MM-DD')
      }
      // 结束时间
      row.endDate = moment(this.monthDate).endOf('month').format('YYYY-MM-DD')
      this.rateManagementForm.fxRatePeriod.push(row)
      console.log('addHandler', row)
      this.$nextTick(() => {
        this.rateGridOptions.api.deselectAll()
        const nodes = this.rateGridOptions.api.getRenderedNodes()
        const lastNode = nodes[nodes.length - 1]
        lastNode.setSelected(true)
        this.rateGridOptions.api.setFocusedCell(lastNode.rowIndex, 'startDate')
      })
    },
    // 删除
    delHandler() {
      const rowDataSelected = getGridSelected(this.rateGridOptions)
      if (rowDataSelected.length === 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      console.log('delHandler', rowDataSelected)
      const periodList = this.rateManagementForm.fxRatePeriod
      for (const item of rowDataSelected) {
        const index = periodList.indexOf(item)
        periodList.splice(index, 1)
      }
      this.rateGridOptions.api.clearFocusedCell()
    },
    rbgUsePeriodRateChangeHandler(value) {
      console.log('rbgUsePeriodRateChangeHandler:', value)
      this.rateManagementForm.usePeriodRate = value
      if (this.rateManagementForm.usePeriodRate && this.rateManagementForm.fxRatePeriod.length === 0) {
        this.addHandler()
      }
    },
    disabledDate(time) {
      if (this.monthDate) {
        return moment(time.getTime()).format('YYYY-MM') !== moment(this.monthDate).format('YYYY-MM')
      }
      return false
    },
    // 检查汇率-生效日期
    toCheckRatePeriod() {
      if (this.rateManagementForm.usePeriodRate) {
        for (const ratePeriod of this.rateManagementForm.fxRatePeriod) {
          // 开始时间、结束时间
          if (!ratePeriod.startDate) {
            this.$message.error(this.$t('Pricing.StartTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
            return false
          }
          if (!ratePeriod.endDate) {
            this.$message.error(this.$t('Pricing.EndTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
            return false
          }
          if (moment(ratePeriod.startDate).format('yyyy-MM-DD') > moment(ratePeriod.endDate).format('yyyy-MM-DD')) {
            this.$message.error(this.$t('Pricing.CompareTime'))
            return false
          }
          // 汇率
          if (!this.$numeral(ratePeriod.rate).value()) {
            this.$message.error(this.$t('baseInfo.rateManagement.rateCheck'))
            return false
          }
          // 汇率长度限制
          const rateLength = ratePeriod.rate.split('.')[0].length
          if (rateLength.length > 6) {
            this.$message.error(this.$t('Pricing.StartTime') + ': ' + moment(ratePeriod.startDate).format('yyyy-MM-DD') + ', ' + this.$t('baseInfo.rateManagement.rateIsTooLong'))
            return false
          }
          // 重复配置
          for (const ratePeriod2 of this.rateManagementForm.fxRatePeriod) {
            if (ratePeriod.index !== ratePeriod2.index) {
              // startDate
              if (moment(ratePeriod.startDate).format('yyyy-MM-DD') >= moment(ratePeriod2.startDate).format('yyyy-MM-DD') &&
                moment(ratePeriod.startDate).format('yyyy-MM-DD') <= moment(ratePeriod2.endDate).format('yyyy-MM-DD')) {
                this.$message.error(this.$t('Pricing.StartTime') + ': ' + moment(ratePeriod.startDate).format('yyyy-MM-DD') + ', ' + this.$t('baseInfo.rateManagement.repeatCheck'))
                return false
              }
              // endDate
              if (moment(ratePeriod.endDate).format('yyyy-MM-DD') >= moment(ratePeriod2.startDate).format('yyyy-MM-DD') &&
                moment(ratePeriod.endDate).format('yyyy-MM-DD') <= moment(ratePeriod2.endDate).format('yyyy-MM-DD')) {
                this.$message.error(this.$t('Pricing.EndTime') + ': ' + moment(ratePeriod.endDate).format('yyyy-MM-DD') + ', ' + this.$t('baseInfo.rateManagement.repeatCheck'))
                return false
              }
            }
          }
        }
      }
      return true
    },
    fetchCopyRateAll(bSaveCopy) {
      if (this.copyRateUuids.length === 0) return
      getRatePeriodList({ uuids: this.copyRateUuids, hqRate: this.hqRate, copyHqRate: this.copyHqRate, branchId: this.officeId }).then(res => {
        this.copyRatePeriodList = res.data
        if (this.copyRatePeriodList.length > 0) {
          const currentMonth = this.currentMonth.toString()
          const copyCurrentMonth = this.copyCurrentMonth.toString()
          const currentMonthDate = currentMonth.slice(0, 4) + '-' + currentMonth.slice(4) + '-01'
          const copyCurrentMonthDate = copyCurrentMonth.slice(0, 4) + '-' + copyCurrentMonth.slice(4) + '-01'
          const diff = moment(currentMonthDate).diff(moment(copyCurrentMonthDate), 'months')
          for (const rate of this.copyRatePeriodList) {
            if (rate.month === this.currentMonth) continue
            rate.month = this.currentMonth
            // 开始、结束时间
            rate.startDate = moment(rate.startDate).add(diff, 'month')
            rate.endDate = moment(rate.endDate).add(diff, 'month')
          }
          this.rowData = this.copyRatePeriodList
          if (bSaveCopy) {
            this.copySave()
            this.showCopyMaintain = false
          }
        }
      }).catch(() => {
      })
    },
    initRatePeriodHandler() {
      this.copySaving = true
      this.loading = getLoading()
      initRatePeriod({ 'currentYearMonth': this.currentMonth }).then(() => {
        this.refreshRateCache()
        this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
      }).finally(() => {
        this.copySaving = false
        this.loading.close()
      })
    },
    refreshRateCache() {
      if (!this.hqRate) {
        syncSpecificBasicData(basicCacheKeys.basic_data_FxRateBranch)
      } else {
        syncSpecificBasicData(basicCacheKeys.basic_data_FxRate)
        syncSpecificBasicData(basicCacheKeys.basic_data_FxRatePeriod)
      }
    },
    // 获取是否对下级子公司生效
    getEnabledChildOffice() {
      this.enabledChildOffice = false
      getOfficeById(this.officeId).then(res => { this.enabledChildOffice = res.data.enabledChildOffice || false })
    },
    setShowParentRateOffice(data) {
      if (!this.hqRate) {
        if (data && data.enabled && data.parentBranchId && data.parentBranchId !== this.officeId) {
          const branchName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', data.parentBranchId, 'chineseName')
          this.showParentRateOffice = this.$t('CargoMsg.Cargo_ShowParentRateOffice', [branchName])
        } else {
          this.showParentRateOffice = ''
        }
      }
    },
    // 设置子公司生效
    popSetEnabledChildDialog() {
      this.setEnabledChildValue = this.enabledChildOffice
      this.showSetEnabledChildDialog = true
    },
    async submitSetEnabledChild() {
      this.cancelSetEnabledChild()
      await this.$confirm(this.$t('CargoMsg.Cargo_SureDoThis'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning' })
      this.loading = getLoading()
      setEnabledChild({ currentYearMonth: this.currentMonth, hqRate: this.hqRate, branchId: this.officeId, enabledChildOffice: this.setEnabledChildValue }).then(() => {
        this.setEnabledChildSuccess()
      }).finally(() => {
        this.loading.close()
      })
    },
    setEnabledChildSuccess() {
      this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
      syncSpecificBasicData(basicCacheKeys.basic_data_FxRateBranch)
      this.getEnabledChildOffice()
    },
    cancelSetEnabledChild() {
      this.showSetEnabledChildDialog = false
    }
  }
}
</script>
